import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import news from '@/components/news'
import newsBrowse from '@/components/newsBrowse'
import about from '@/components/about'
import product from '@/components/product'
import cooperate from '@/components/cooperate'
import partner from '@/components/partner'
import contact from '@/components/contact'
import hotel from '@/components/product/hotel'
import pos from '@/components/product/pos'
import purchase from '@/components/product/purchase'

import booking from '@/components/product/booking'

import member from '@/components/product/member'

import humanresource from '@/components/product/humanresource'
import finance from '@/components/product/finance'
import fix from '@/components/product/fix'
import securities from '@/components/product/securities'
import combine from '@/components/product/combine'
import phone from '@/components/product/phone'
import sale from '@/components/product/sale'


Vue.use(Router)

export default new Router({
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 } // 每次切換view都將頁面拉回頂部
    },
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: home
		},{
			path: '/news',
			name: 'news',
			component: news
		},
		{
			path: '/news/:id',
			name: 'newsBrowse',
			component: newsBrowse
		},
		{
			path: '/about',
			name: 'about',
			component: about
		},
		{
			path: '/product',
			name: 'product',
			component: product,
			children:[
			{
				path: 'hotel',
				name: 'hotel',
				component: hotel
			},{
				path: 'pos',
				name: 'pos',
				component: pos
			},{
				path: 'purchase',
				name: 'purchase',
				component: purchase
			},{
				path: 'booking',
				name: 'booking',
				component: booking
			},{
				path: 'member',
				name: 'member',
				component: member
			},{
				path: 'humanresource',
				name: 'humanresource',
				component: humanresource
			},{
				path: 'finance',
				name: 'finance',
				component: finance
			},{
				path: 'fix',
				name: 'fix',
				component: fix
			},{
				path: 'securities',
				name: 'securities',
				component: securities
			},{
				path: 'combine',
				name: 'combine',
				component: combine
			},{
				path: 'phone',
				name: 'phone',
				component: phone
			},{
				path: 'sale',
				name: 'sale',
				component: sale
			}]
		},
		{
			path: '/cooperate',
			name: 'cooperate',
			component: cooperate
		},
		{
			path: '/partner',
			name: 'partner',
			component: partner
		},
		{
			path: '/contact',
			name: 'contact',
			component: contact
		},
		{ path: "*", redirect:"/" }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js